<template>
  <div class="replacementmonthlystatistics__report__view">    
    <div class="reports__subheader">
      <submit-panel @submit="addCircle" text="Opret kreds" v-if="hasEditRights">
      </submit-panel>
    </div>
    <b-table :data="circles"
             :loading="loading"
             @click="onRowClick"
             hoverable>

      <b-table-column field="title"
                      label="Navn"
                      searchable
                      v-slot="props">
        {{ props.row.title }}
      </b-table-column>

      <b-table-column field="type"
                      label="Type"
                      searchable
                      v-slot="props">
        {{ props.row.type }}
      </b-table-column>

      <b-table-column field="addDays"
                      label="Tilføj dage"
                      searchable
                      v-slot="props">
        {{ props.row.addDays }}
      </b-table-column>

      <b-table-column field="colorCode"
                      label="Farve"
                      searchable
                      v-slot="props">
        {{ props.row.colorCode }}
      </b-table-column>

      <b-table-column>
        <span>
          <b-icon pack="fas"
                  icon="angle-right"></b-icon>
        </span>
        <template v-slot:header>
          <div @click="addCircle"
               class="register-user">
            <b-icon pack="fas"
                    icon="plus"></b-icon>
          </div>
        </template>
      </b-table-column>

    </b-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ApiState from "../enums/APISTATE";
import SubmitPanel from '@/components/report/SubmitPanel.vue';

export default {
  name: "circles-view",
  components: {SubmitPanel},
  data: () => ({
    colorsHex: [],
  }),
  async mounted() {
    await this.loadCircles();
  },
  computed: {
    ...mapGetters("circles", ["circleApiState", "circles"]),
    ...mapGetters(["currentUser", "hasEditRights"]),
    loading() {
      return this.circleApiState !== ApiState.LOADED;
    },
  },
  methods: {
    ...mapActions("circles", ["loadCircles"]),
    onRowClick(row) {
      this.$router.push(`/configuration/circles/${row.id}/edit`);
    },
    addCircle() {
      this.$router.push("/configuration/circles/new");
    },
  },
};
</script>

<style lang="scss" scoped>
.users-view {
  .register-user {
    cursor: pointer;
    width: 100%;
  }
}

.table td {
  text-align: left !important;
}
</style>
